<template>
  <div class="netWork" v-if="isNetWork">
    <div class="tit">正在等待网络通讯...</div>
  </div>
</template>
<script>
export default {
  props:{
    isNetWork:{
      type:Boolean,
      required: true
    }
  },
  data(){
    return{
      
    }
  },
  methods:{
    
  },

}
</script>
<style lang="less">
.netWork{
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  box-sizing: border-box;
  text-align: center;
  background-color: rgba(0, 0, 0, .6);
  .tit{
    width: 30%;
    background: #fff;
    border-radius: 0.1rem;
    margin: 1.5rem auto;
    padding: 0.2rem;
    font-size: 0.4rem;
    color: #666;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/assets/netWork.vue